module.exports = __webpack_public_path__ + "static/media/arrow-back-insta.0a10a8d5.svg";